/* ==========================================================================
   Nooroots | Ashwagandha & Lion's Mane Formula Comparison
   INTERFACE, SHOPIFY VERSION (from version 2)

   Online file name: assets/ashlion-formula-comparison-ui.js
   Used by sections/ashlion-formula-comparison.liquid.
   Same as ashlion-formula-comparison-ui-2.js, except the button text comes from
   the section's "Button text" setting (data-comparison-button-label).
   The short form is translated into the engine's field names in toEngineValues().
   All text from the dataset or the user is inserted as text, never as HTML.
   Needs: ashlion-formula-comparison-engine.js and ashlion-formula-comparison-data.js
   ========================================================================== */
(function (win, doc) {
  'use strict';

  var E = win.AshlionComparisonEngine;
  var D = win.AshlionComparisonData;
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var PLURAL = { capsule: 'capsules', tablet: 'tablets', gummy: 'gummies', sachet: 'sachets', scoop: 'scoops', pipette: 'pipettes' };
  var MARKERS_OF = { ash: ['withanolides'], lm: ['polysaccharides', 'beta_glucans'] };

  var EXAMPLE = {
    ash_amount: '300', ash_type: 'extract', withanolides_percent: '5',
    lm_amount: '500', lm_type: 'extract', polysaccharides_percent: '30',
    basis_quantity: '2', basis_unit: 'capsule', routine_min: '2',
    price_gbp: '18.00', pack_quantity: '60', pack_unit: 'capsule', is_adult: 'yes'
  };
  var EXAMPLE_TEXT = 'Example label: 300 mg ashwagandha extract (5% withanolides) and 500 mg lion’s mane extract (30% polysaccharides) per 2 capsules, 2 capsules a day, £18.00 for 60 capsules.';

  // Friendly names for error messages.
  var NAMES = {
    formula_id: 'Product', ash_amount: 'Ashwagandha amount', lm_amount: 'Lion’s mane amount',
    ash_type: 'Ashwagandha: what the label calls it', lm_type: 'Lion’s mane: what the label calls it',
    withanolides_percent: 'Withanolides %', polysaccharides_percent: 'Polysaccharides %', beta_glucans_percent: 'Beta-glucans %',
    basis_quantity: 'Serving size', routine_min: 'Number to take each day', routine_max: 'Top of the daily range',
    price_gbp: 'Price paid', pack_quantity: 'Pack size',
    ash_amount_max: 'Ashwagandha top of the range', lm_amount_max: 'Lion’s mane top of the range',
    lm_split_extract_mg: 'Lion’s mane extract (mg)', lm_split_biomass_mg: 'Mycelium or biomass (mg)',
    withanolides_reported_mg: 'Withanolides (mg)', polysaccharides_reported_mg: 'Polysaccharides (mg)', beta_glucans_reported_mg: 'Beta-glucans (mg)',
    conversion_value: 'Scoop or pipette conversion'
  };
  // Engine fields that have no V2 input of their own.
  var FALLBACK = {
    withanolides_percent_max: 'withanolides_percent', polysaccharides_percent_max: 'polysaccharides_percent', beta_glucans_percent_max: 'beta_glucans_percent',
    withanolides_reported_mg_max: 'withanolides_reported_mg', polysaccharides_reported_mg_max: 'polysaccharides_reported_mg', beta_glucans_reported_mg_max: 'beta_glucans_reported_mg',
    routine_unit: 'routine_min'
  };
  var EXAMPLE_NUMBER = { price_gbp: '18.99', ash_amount: '300', lm_amount: '500' };

  /* ---------- small helpers ---------- */

  function el(tag, attrs, children) {
    var node = doc.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (attrs[k] === null || attrs[k] === undefined || attrs[k] === false) return;
      if (k === 'text') node.textContent = attrs[k];
      else if (k === 'class') node.className = attrs[k];
      else node.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (children || []).forEach(function (c) {
      if (c === null || c === undefined || c === false) return;
      node.appendChild(typeof c === 'string' ? doc.createTextNode(c) : c);
    });
    return node;
  }

  function longDate(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
    return m ? Number(m[3]) + ' ' + MONTHS[Number(m[2]) - 1] + ' ' + m[1] : '';
  }

  function unitWord(unit, qty) {
    if (!unit) return '';
    return qty === 1 || unit === 'g' || unit === 'ml' ? unit : (PLURAL[unit] || unit);
  }

  // Opens closed <details> and revealed sections so a field can be seen and focused.
  function reveal(node) {
    for (var p = node && node.parentNode; p && p.nodeType === 1; p = p.parentNode) {
      if (p.tagName === 'DETAILS') p.open = true;
      if (p.hidden && p.hasAttribute('data-comparison-collapsible')) {
        p.hidden = false;
        var toggle = doc.querySelector('[data-comparison-reveal="' + p.id + '"]');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      }
    }
  }

  // "150–450 mg per day" -> { prefix: '', value: '150–450', unit: 'mg per day' }
  function splitValue(formatted) {
    var m = /^(at least |up to )?(.*?)(?: (mg|days))?(?: ((?:per|for) .*))?$/.exec(formatted || '');
    if (!m) return { prefix: '', value: formatted, unit: '' };
    return { prefix: m[1] || '', value: m[2], unit: [m[3], m[4]].filter(Boolean).join(' ') };
  }

  function has(list, x) { return list.indexOf(x) !== -1; }

  /* ---------- one calculator instance ---------- */

  function init(root) {
    if (!root || root.getAttribute('data-comparison-ready') === 'true') return;
    root.setAttribute('data-comparison-ready', 'true');

    var q = function (sel) { return root.querySelector(sel); };
    var form = q('[data-comparison-form]');
    var submit = q('[data-comparison-submit]');
    var submitHelp = doc.getElementById(submit.getAttribute('aria-describedby'));
    var errorBox = q('[data-comparison-errors]');
    var errorLinks = q('[data-comparison-error-links]');
    var productSelect = q('[data-comparison-product]');
    var catalogueHelp = doc.getElementById('catalogue-help');
    var productSummary = q('[data-comparison-product-summary]');
    var sourceBanner = q('[data-comparison-source-banner]');
    var results = q('[data-comparison-results]');
    var resultList = q('[data-comparison-result-list]');
    var status = q('[data-comparison-status]');
    var trust = q('[data-comparison-trust]');
    var guide = q('[data-comparison-guide]');
    var routineUnitText = q('[data-comparison-routine-unit]');
    var datasetUrl = root.getAttribute('data-comparison-dataset-url') || D.DEFAULT_URL;
    var buttonLabel = (root.getAttribute('data-comparison-button-label') || '').trim() || 'Show my results';

    var state = { dataset: null, linked: null, hasResults: false, stale: false, ignoreInvalid: false, example: false, packTouched: false };

    if (!E || !D) { if (submitHelp) submitHelp.textContent = 'The calculator did not load. Please refresh the page.'; return; }

    // The engine works without the dataset, so the button is usable at once.
    submit.disabled = false;
    if (submitHelp) submitHelp.textContent = 'Nothing you enter is saved or sent anywhere.';
    if (guide && win.matchMedia && win.matchMedia('(min-width: 901px)').matches) guide.open = true;

    /* ----- route tabs ----- */

    function route() {
      var r = form.querySelector('[data-comparison-route]:checked');
      return r ? r.value : 'manual';
    }

    function showRoute() {
      var r = route();
      Array.prototype.forEach.call(root.querySelectorAll('[data-comparison-panel]'), function (p) {
        p.hidden = p.getAttribute('data-comparison-panel') !== r;
      });
      if (!state.hasResults) setButtonText(buttonLabel);
    }

    function setRoute(r) {
      Array.prototype.forEach.call(form.elements.entry_route, function (x) { x.checked = x.value === r; });
      showRoute();
    }

    function setButtonText(text) {
      for (var i = 0; i < submit.childNodes.length; i++) {
        if (submit.childNodes[i].nodeType === 3 && submit.childNodes[i].nodeValue.trim()) { submit.childNodes[i].nodeValue = text + ' '; return; }
      }
      submit.insertBefore(doc.createTextNode(text + ' '), submit.firstChild);
    }

    /* ----- dataset, trust line and reviewed products ----- */

    function loadDataset() {
      productSelect.disabled = true;
      productSelect.textContent = '';
      productSelect.appendChild(el('option', { value: '', text: 'Loading reviewed products…' }));
      return D.load(datasetUrl).then(function (res) {
        if (res.ok) {
          state.dataset = res.dataset;
          fillProducts();
          showTrust();
        } else {
          state.dataset = null;
          productSelect.textContent = '';
          productSelect.appendChild(el('option', { value: '', text: 'Reviewed products are unavailable right now' }));
          if (catalogueHelp) catalogueHelp.textContent = 'The reviewed products could not be loaded. You can still type in your label; comparisons will return once they load.';
        }
        if (state.hasResults && !state.stale) run(state.ignoreInvalid, true);
        return res;
      });
    }

    function showTrust() {
      if (!trust) return;
      var recs = state.dataset.formula_records.filter(function (r) { return r.status === 'active' && r.adult_comparator; });
      var brands = {};
      recs.forEach(function (r) { brands[r.brand] = true; });
      var n = Object.keys(brands).length;
      trust.textContent = 'Compared with ' + recs.length + ' reviewed UK formulas from ' + n + ' brands' + (brands.Nooroots ? ', including Nooroots' : '') +
        '. The same rules for every brand.';
    }

    function fillProducts() {
      productSelect.textContent = '';
      productSelect.appendChild(el('option', { value: '', text: 'Choose a product' }));
      E.catalogueOptions(state.dataset).forEach(function (o) {
        productSelect.appendChild(el('option', { value: o.formula_id, text: o.label + (o.adult_comparator ? '' : ' (not in the adult comparison)') }));
      });
      productSelect.disabled = false;
      if (catalogueHelp) catalogueHelp.textContent = 'Recorded label details and normal prices, reviewed ' + longDate(state.dataset.research_snapshot_date) + '.';
      showProductSummary();
    }

    function selectedRecord() {
      return state.dataset && productSelect.value ? E.findFormula(state.dataset, productSelect.value) : null;
    }

    function describeMeasurements(ing) {
      var parts = [];
      ing.measurements.forEach(function (m) {
        if (m.value_state !== 'known' || !(m.amount_min_mg >= 0)) return;
        var amount = m.qualifier === 'minimum' ? 'at least ' + E.formatMg(m.amount_min_mg)
          : m.amount_max_mg !== m.amount_min_mg && m.amount_max_mg !== null ? E.formatMg(m.amount_min_mg).replace(' mg', '') + '–' + E.formatMg(m.amount_max_mg) : E.formatMg(m.amount_min_mg);
        var prep = { extract: 'extract', powder: 'powder', biomass: 'mycelium biomass' }[m.preparation] || 'form not stated';
        var basis = m.basis && m.basis.quantity && m.basis.unit !== 'unconverted_unit' ? ' per ' + m.basis.quantity + ' ' + unitWord(m.basis.unit, m.basis.quantity) : '';
        parts.push(amount + ' ' + prep + basis);
      });
      if (!parts.length && ing.unresolved_headline_amount && ing.unresolved_headline_amount.value_state === 'known') parts.push('“' + ing.unresolved_headline_amount.source_text + ' mg” as printed, meaning unclear');
      return parts.length ? parts.join('; ') : 'amount not stated';
    }

    function recordedOffer(rec) {
      return rec.offers.filter(function (o) { return o.price_class === 'recorded_normal_list'; })[0];
    }

    function showProductSummary() {
      if (!productSummary) return;
      var rec = selectedRecord();
      productSummary.textContent = '';
      if (!rec) return;
      var offer = recordedOffer(rec);
      var rows = [];
      rec.ingredients.forEach(function (ing) {
        rows.push(el('div', null, [el('dt', { text: ing.ingredient === 'ashwagandha' ? 'Ashwagandha' : 'Lion’s mane' }), el('dd', { text: describeMeasurements(ing) })]));
      });
      rows.push(el('div', null, [el('dt', { text: 'Directions' }), el('dd', { text: rec.routine.instructions || 'Not found' })]));
      if (offer && offer.total_gbp !== null) {
        rows.push(el('div', null, [el('dt', { text: 'Normal price' }), el('dd', {
          text: E.formatGBP(offer.total_gbp) + (offer.pack_quantity ? ' for ' + offer.pack_quantity + ' ' + unitWord(offer.pack_unit, offer.pack_quantity) : '') +
            (offer.observed_at ? ', seen ' + longDate(offer.observed_at) : '') + (offer.orderability === 'unavailable' ? ' (offer unavailable)' : '')
        })]));
      }
      productSummary.appendChild(el('strong', { text: 'Does this match your label?' }));
      productSummary.appendChild(el('p', { text: rec.brand + ' – ' + rec.name + ', reviewed ' + longDate(rec.reviewed_at) + '.' +
        (rec.adult_comparator ? '' : ' This product is not part of the adult comparison group, so it gets no ranking.') }));
      productSummary.appendChild(el('dl', { class: 'acmp-facts' }, rows));
      productSummary.appendChild(el('button', { type: 'button', class: 'acmp-secondary', 'data-comparison-edit-product': true, text: 'My label is different: edit these details' }));
    }

    /* ----- setting fields ----- */

    function setField(name, value) {
      var f = form.elements[name];
      if (!f || value === null || value === undefined) return false;
      var v = String(value);
      if (!f.tagName) { // radio group
        var hit = false;
        Array.prototype.forEach.call(f, function (x) { x.checked = x.value === v; if (x.checked) hit = true; });
        return hit;
      }
      if (f.type === 'checkbox') { f.checked = value === true || v === 'yes'; return true; }
      if (f.tagName === 'SELECT' && !Array.prototype.some.call(f.options, function (o) { return o.value === v; })) return false;
      f.value = v;
      return true;
    }

    function setRange(open) {
      var box = doc.getElementById('routine-range');
      var toggle = q('[data-comparison-reveal="routine-range"]');
      if (!box) return;
      box.hidden = !open;
      if (toggle) toggle.setAttribute('aria-expanded', String(!!open));
      if (!open) form.elements.routine_max.value = '';
    }

    function clearManual() {
      var keepRoute = route();
      var keepProduct = productSelect.value;
      form.reset();
      ['ash_presence', 'lm_presence', 'age_population', 'offer_orderability'].forEach(function (n) { form.elements[n].value = ''; });
      setRoute(keepRoute);
      productSelect.value = keepProduct;
      setRange(false);
      state.packTouched = false;
      state.example = false;
    }

    function updateUnits() {
      var basis = form.elements.basis_unit.value;
      if (!state.packTouched && basis !== 'day') setField('pack_unit', basis);
      var unit = form.elements.routine_unit.value || (basis !== 'day' ? basis : form.elements.pack_unit.value);
      var min = form.elements.routine_min.value.trim();
      var max = form.elements.routine_max.value.trim();
      var one = min === '1' && (!max || max === '1');
      if (routineUnitText) routineUnitText.textContent = unitWord(unit, one ? 1 : 2) + ' a day';
    }

    /* ----- prefill the quick form from a reviewed record ----- */

    function prefillFrom(rec) {
      clearManual();
      setRoute('manual');
      productSelect.value = rec.formula_id;
      var notes = [];

      setField('is_adult', rec.age_population === 'adult_general');
      if (rec.age_population !== 'adult_general') setField('age_population', { children: 'children', mixed_unresolved: 'mixed' }[rec.age_population] || '');

      var bases = rec.ingredients.map(function (ing) { return ing.basis; })
        .filter(function (b) { return b && b.value_state === 'known' && b.quantity > 0 && b.unit !== 'unconverted_unit'; });
      var shared = bases.length && bases.every(function (b) { return b.quantity === bases[0].quantity && b.unit === bases[0].unit; }) ? bases[0] : null;
      // "Per 2 units, take 2 units daily" for one ingredient only: the amount is already a daily total.
      var dailyTotal = !shared && rec.ingredients.every(function (ing) {
        var r = ing.routine, b = ing.basis;
        return !ing.measurements.some(function (m) { return m.calculation_eligible; }) ||
          (r && r.scope === 'ingredient_specific' && r.value_state === 'known' && b && r.quantity_min === b.quantity && r.quantity_max === b.quantity && r.unit === b.unit);
      }) && rec.ingredients.some(function (ing) { return ing.routine && ing.routine.scope === 'ingredient_specific'; });
      if (shared) { setField('basis_quantity', shared.quantity); setField('basis_unit', shared.unit); }
      else if (dailyTotal) setField('basis_unit', 'day');
      else notes.push('The serving size is not clear on this label, so it is left blank.');

      var R = rec.routine;
      if (R.value_state === 'known' && R.calculation_eligible) {
        setField('routine_min', R.quantity_min);
        if (R.qualifier === 'finite_range') { setRange(true); setField('routine_max', R.quantity_max); }
        if (!shared || R.unit !== shared.unit) setField('routine_unit', R.unit);
      } else {
        notes.push('The daily directions are ' + (R.value_state === 'conflicting' ? 'conflicting' : 'unclear or missing') + ' on this label, so they are left blank.');
      }

      rec.ingredients.forEach(function (ing) {
        var px = ing.ingredient === 'ashwagandha' ? 'ash' : 'lm';
        var name = px === 'ash' ? 'Ashwagandha' : 'Lion’s mane';
        var present = !!rec.ingredient_presence[ing.ingredient];
        setField(px + '_presence', present ? 'yes' : 'no');
        var ms = ing.measurements.filter(function (m) { return m.calculation_eligible && m.value_state === 'known'; });
        var fieldFor = {};
        if (ms.length === 1 && !(px === 'lm' && ms[0].preparation === 'biomass')) {
          var m = ms[0];
          setField(px + '_amount', m.amount_min_mg);
          setField(px + '_amount_unit', 'mg');
          setField(px + '_type', m.preparation === 'extract' && m.extract_comparison_eligible ? 'extract' : m.preparation === 'powder' ? 'powder' : 'unsure');
          if (m.qualifier === 'finite_range') { setField(px + '_qualifier', 'finite_range'); setField(px + '_amount_max', m.amount_max_mg); }
          else if (m.qualifier === 'minimum') setField(px + '_qualifier', 'minimum');
          fieldFor[m.measurement_id] = true;
        } else if (ms.length) {
          ms.forEach(function (m) {
            var split = px === 'lm' ? { extract: 'lm_split_extract_mg', biomass: 'lm_split_biomass_mg' }[m.preparation] : null;
            if (split && setField(split, m.amount_min_mg)) fieldFor[m.measurement_id] = true;
            else notes.push(name + ': part of the amount could not be shown in this form.');
          });
        } else if (present) {
          notes.push(name + ': the label’s amount is not clear enough to use, so it is left blank.');
        }
        ing.markers.forEach(function (k) {
          if (!k.calculation_eligible || k.value_state !== 'known') return;
          if (k.origin === 'reported' && k.amount_min_mg !== null) setField(k.name + '_reported_mg', k.amount_min_mg);
          if (k.percentage_value_state === 'known' && k.percentage_min !== null && fieldFor[k.linked_measurement_id]) setField(k.name + '_percent', k.percentage_min);
          if (k.percentage_qualifier === 'minimum' || k.qualifier === 'minimum') setField('marker_minimum', true);
        });
      });

      var offer = recordedOffer(rec);
      if (offer && offer.total_gbp !== null) {
        setField('price_gbp', offer.total_gbp.toFixed(2));
        setField('pack_quantity', offer.pack_quantity);
        setField('pack_unit', offer.pack_unit);
        state.packTouched = true;
        if (offer.orderability === 'unavailable') {
          setField('offer_orderability', 'unavailable');
          notes.push('This offer was unavailable when reviewed, so its price is not ranked.');
        }
      }

      state.linked = { formula_id: rec.formula_id, label: rec.brand + ' – ' + rec.name, reviewed_at: rec.reviewed_at, notes: notes };
      updateUnits();
      showSourceBanner();
      if (sourceBanner.scrollIntoView) sourceBanner.scrollIntoView({ block: 'start' });
      status.textContent = 'The form now holds the recorded details for ' + state.linked.label + '. Check them against your label.';
    }

    function showSourceBanner() {
      if (!sourceBanner) return;
      sourceBanner.textContent = '';
      sourceBanner.hidden = !state.linked;
      if (!state.linked) return;
      sourceBanner.appendChild(el('strong', { text: 'Started from ' + state.linked.label + ' (reviewed ' + longDate(state.linked.reviewed_at) + ')' }));
      sourceBanner.appendChild(el('p', { text: 'Change anything that differs on your label. Your changes stay on this page, and this product is left out of its own comparison.' }));
      (state.linked.notes || []).forEach(function (n) { sourceBanner.appendChild(el('p', { text: n })); });
      sourceBanner.appendChild(el('button', { type: 'button', class: 'acmp-secondary', 'data-comparison-unlink': true, text: 'This is a different product' }));
    }

    /* ----- reading values ----- */

    function readValues() {
      var values = {};
      Array.prototype.forEach.call(form.elements, function (f) {
        if (!f.name || f.disabled) return;
        if ((f.type === 'radio' || f.type === 'checkbox') && !f.checked) return;
        values[f.name] = f.value;
      });
      return values;
    }

    // Translate the quick form into the engine's (version 1) field names.
    function toEngineValues(raw) {
      var out = {};
      var errors = [];
      function given(n) { return raw[n] !== undefined && String(raw[n]).trim() !== ''; }
      function copy(n) { if (given(n)) out[n] = raw[n]; }

      var basisUnit = raw.basis_unit || '';
      if (basisUnit === 'day') out.basis_type = 'daily';
      else if (given('basis_quantity')) { out.basis_type = 'physical_serving'; out.basis_quantity = raw.basis_quantity; out.basis_unit = basisUnit; }

      if (given('routine_min')) {
        out.routine_status = given('routine_max') ? 'finite_range' : 'fixed';
        out.routine_min = raw.routine_min;
        copy('routine_max');
        out.routine_unit = raw.routine_unit || (basisUnit !== 'day' ? basisUnit : (raw.pack_unit || ''));
      } else if (given('routine_max')) {
        errors.push({ field: 'routine_min', message: 'Enter the lowest number to take each day' });
      }
      if (given('conversion_value')) { out.conversion_value = raw.conversion_value; out.conversion_unit = raw.conversion_unit; }

      ['ash', 'lm'].forEach(function (px) {
        var amount = given(px + '_amount');
        var type = raw[px + '_type'] || '';
        var split = px === 'lm' && (given('lm_split_extract_mg') || given('lm_split_biomass_mg'));
        var markerGiven = MARKERS_OF[px].some(function (m) { return given(m + '_percent') || given(m + '_reported_mg'); });
        if (amount) {
          if (!type) errors.push({ field: px + '_type', message: 'Choose one. If the label just gives an amount, choose “No form stated”' });
          out[px + '_amount'] = raw[px + '_amount'];
          out[px + '_amount_unit'] = raw[px + '_amount_unit'] || 'mg';
          if (raw[px + '_qualifier'] === 'minimum' || raw[px + '_qualifier'] === 'finite_range') out[px + '_qualifier'] = raw[px + '_qualifier'];
          if (raw[px + '_qualifier'] !== 'minimum') copy(px + '_amount_max');
          out[px + '_amount_kind'] = type === 'equivalent' ? 'raw_equivalent' : 'actual_preparation';
          out[px + '_preparation'] = type === 'extract' ? 'extract' : type === 'powder' ? 'powder' : 'unknown';
        }
        if (px === 'lm') { copy('lm_split_extract_mg'); copy('lm_split_biomass_mg'); }
        out[px + '_presence'] = amount || split || markerGiven ? 'yes' : (raw[px + '_presence'] || '');
        var linkTo = amount && type !== 'equivalent' ? px + '_amount' : px === 'lm' && given('lm_split_extract_mg') ? 'lm_split_extract' : 'unknown';
        MARKERS_OF[px].forEach(function (m) {
          if (given(m + '_percent')) { out[m + '_percent'] = raw[m + '_percent']; out[m + '_linked_measurement'] = linkTo; }
          if (given(m + '_reported_mg')) { out[m + '_reported_mg'] = raw[m + '_reported_mg']; out[m + '_basis'] = 'ingredient'; }
          if ((given(m + '_percent') || given(m + '_reported_mg')) && raw.marker_minimum) out[m + '_qualifier'] = 'minimum';
        });
      });

      if (given('price_gbp') || given('pack_quantity')) {
        copy('price_gbp');
        copy('pack_quantity');
        out.pack_unit = raw.pack_unit || '';
        out.price_class = raw.price_discounted ? 'promotion' : 'one_time';
        if (raw.offer_orderability) out.offer_orderability = raw.offer_orderability;
      }
      out.age_population = raw.is_adult ? 'adult' : (raw.age_population || '');
      return { values: out, errors: errors };
    }

    /* ----- errors ----- */

    function fieldInfo(name) {
      var f = form.elements[name] || form.elements[FALLBACK[name] || ''];
      var label = NAMES[name] || NAMES[FALLBACK[name]] || name;
      if (!f) return { label: label };
      if (!f.tagName) { // radio group: mark its fieldset
        var group = f[0] && f[0].closest('fieldset');
        return { focus: f[0], box: group, after: group && group.lastElementChild, label: label };
      }
      var wrap = f.parentNode.classList.contains('acmp-join') ? f.parentNode : f;
      return { focus: f, input: f, box: wrap, after: wrap, label: label };
    }

    function friendly(e) {
      var m = e.message || 'Check this value';
      if (/as a number/.test(m)) return 'Enter a number, like ' + (EXAMPLE_NUMBER[e.field] || (/percent/.test(e.field) ? '5' : /_mg/.test(e.field) ? '10' : '2'));
      if (/greater than 0/.test(m)) return 'Enter a number above 0';
      if (/of 0 or more/.test(m)) return 'Enter 0 or more';
      return m;
    }

    function clearErrors() {
      errorBox.hidden = true;
      errorLinks.textContent = '';
      Array.prototype.forEach.call(form.querySelectorAll('.acmp-field-error'), function (p) { p.parentNode.removeChild(p); });
      Array.prototype.forEach.call(form.querySelectorAll('.is-invalid'), function (b) { b.classList.remove('is-invalid'); });
      Array.prototype.forEach.call(form.querySelectorAll('[aria-invalid="true"]'), function (f) {
        f.removeAttribute('aria-invalid');
        var orig = f.getAttribute('data-comparison-describedby');
        if (orig !== null) { if (orig) f.setAttribute('aria-describedby', orig); else f.removeAttribute('aria-describedby'); }
      });
      var skip = errorBox.querySelector('[data-comparison-skip-invalid]');
      if (skip) skip.parentNode.removeChild(skip);
    }

    function showErrors(errors, allowSkip) {
      var seen = {};
      errors.forEach(function (e) {
        var info = fieldInfo(e.field);
        var key = info.box ? (info.focus.id || info.focus.name) : e.field;
        if (seen[key]) return;
        seen[key] = true;
        var msg = friendly(e);
        var errId = 'error-' + e.field.replace(/_/g, '-');
        if (info.box) {
          info.box.classList.add('is-invalid');
          var p = el('p', { class: 'acmp-field-error', id: errId, text: msg });
          if (info.input) {
            var f = info.input;
            if (f.getAttribute('data-comparison-describedby') === null) f.setAttribute('data-comparison-describedby', f.getAttribute('aria-describedby') || '');
            f.setAttribute('aria-invalid', 'true');
            f.setAttribute('aria-describedby', (errId + ' ' + (f.getAttribute('data-comparison-describedby') || '')).trim());
            info.after.parentNode.insertBefore(p, info.after.nextSibling);
          } else {
            info.box.appendChild(p);
          }
          reveal(info.box);
        }
        var link = el('a', { href: info.focus && info.focus.id ? '#' + info.focus.id : '#comparison-form', text: info.label + ': ' + msg });
        link.addEventListener('click', function (ev) {
          if (!info.focus) return;
          ev.preventDefault();
          reveal(info.focus);
          info.focus.focus();
        });
        errorLinks.appendChild(el('li', null, [link]));
      });
      if (allowSkip) errorBox.appendChild(el('button', { type: 'button', class: 'acmp-secondary', 'data-comparison-skip-invalid': true, text: 'Show results without these details' }));
      errorBox.hidden = false;
      errorBox.focus();
    }

    /* ----- calculate ----- */

    function run(ignoreInvalid, quiet) {
      clearErrors();
      state.ignoreInvalid = !!ignoreInvalid;
      var target, skipped = [];
      if (route() === 'reviewed') {
        var rec = selectedRecord();
        if (!rec) {
          showErrors([{ field: 'formula_id', message: state.dataset ? 'Choose a product, or choose “Type in my label”' : 'Reviewed products are not available right now. Choose “Type in my label” instead' }]);
          return;
        }
        state.example = false;
        target = E.targetFromFormula(rec);
      } else {
        var mapped = toEngineValues(readValues());
        var built = E.buildManualTarget(mapped.values, { source_formula_id: state.linked ? state.linked.formula_id : null });
        var errors = mapped.errors.concat(built.errors);
        if (errors.length && !ignoreInvalid) { showErrors(errors, true); return; }
        target = built.target;
        skipped = errors;
      }
      var resp = E.compare(target, state.dataset);
      render(resp, target, skipped);
      state.hasResults = true;
      state.stale = false;
      results.classList.remove('is-stale');
      setButtonText('Update results');
      var main = resp.primary.length;
      status.textContent = resp.overall_state === 'NO_USABLE_INPUT' ? 'No results yet. Add an amount with its serving size, or a price and pack size.'
        : 'Results updated. ' + main + ' main result' + (main === 1 ? '' : 's') + ' shown below.';
      if (!quiet) {
        var h = doc.getElementById('live-results-heading');
        if (h) h.focus();
      }
    }

    /* ----- results: wording ----- */

    function fmt(id, x) { return /gbp$/.test(id) ? E.formatGBP(x) : E.formatMg(x); }

    // One plain sentence about where the label sits, or why it is not ranked.
    function positionLine(r) {
      var meta = E.BENCHMARK_METRICS[r.metric_id];
      var codes = r.reason_codes;
      if (/_material_mg_/.test(r.metric_id)) return { text: 'The form isn’t stated, so it isn’t compared with extracts or powders. If the label says extract or powder, choose it above.', muted: true };
      if (/_biomass_mg_/.test(r.metric_id)) return { text: 'Mycelium biomass is shown on its own and isn’t ranked.', muted: true };
      if (!meta) return null;
      var c = r.cohort, p = r.position, bs = r.benchmark_state;
      if (r.calculation_state === 'minimum_only') return { text: 'This is an “at least” amount, so it isn’t ranked.', muted: true };
      if (r.calculation_state === 'maximum_only') return { text: 'This is an “up to” amount, so it isn’t ranked.', muted: true };
      if (has(codes, 'DATASET_UNAVAILABLE') || has(codes, 'SCHEMA_INVALID')) return { text: 'The comparison is unavailable right now.', muted: true };
      if (has(codes, 'SCOPE_UNCONFIRMED')) return { text: 'Not compared yet. Answer the question above to see where it sits.', muted: true };
      if (bs === 'out_of_scope') return { text: OUT_OF_SCOPE_SHORT[scopeReason] || 'Not ranked: outside the adult formula group.', muted: true };
      if (has(codes, 'PRICE_CLASS_MISMATCH')) return { text: 'A sale or subscription price, so it isn’t ranked against normal prices.', muted: true };
      if (has(codes, 'OFFER_UNAVAILABLE')) return { text: 'This offer is unavailable, so it isn’t ranked.', muted: true };
      if (bs === 'no_peers') return { text: 'No reviewed formulas list this yet.', muted: true };
      if (bs === 'insufficient_peers') return { text: 'Only ' + c.n + ' reviewed formula' + (c.n === 1 ? '' : 's') + ' list' + (c.n === 1 ? 's' : '') + ' this, too few to compare.', muted: true };
      if (p && (bs === 'available' || bs === 'small_subset')) {
        var L = p.definite_count, H = p.possible_count;
        var count = L === H ? String(L) : L + '–' + H;
        var text = (meta.direction === 'cost' ? 'Costs less than ' : 'Higher than ') + count + ' of ' + c.n + ' comparable formulas';
        return { text: text + (bs === 'small_subset' ? '. A small group, so no ranking is shown.' : '.') };
      }
      return { text: 'Not compared.', muted: true };
    }

    function typical(r) {
      var s = r.summary;
      if (!s || r.benchmark_state !== 'available' || !(s.exact_n >= 10)) return null;
      var day = /_mg_day$|^daily_cost/.test(r.metric_id) ? ' a day' : '';
      return 'Typical of the ' + s.exact_n + ' with fixed daily directions: ' + fmt(r.metric_id, s.median) + day + ' (middle half ' + fmt(r.metric_id, s.p25).replace(/ mg$/, '') + '–' + fmt(r.metric_id, s.p75) + ')';
    }

    function marketLines(r) {
      var lines = [];
      if (!r.cohort) return lines;
      lines.push(r.cohort.n + ' of ' + r.cohort.T + ' reviewed adult formulas list this measurement (snapshot ' + longDate(r.cohort.snapshot_date) + ').');
      var p = r.position;
      if (p && r.benchmark_state === 'available') {
        var b = p.display_bounds;
        lines.push('That is ' + (b[0] === b[1] ? b[0] : b[0] + '–' + b[1]) + '% of them' + (b[0] === b[1] ? '.' : ', depending on their label ranges.'));
      }
      var s = r.summary;
      if (s && s.exact_n >= 10 && r.benchmark_state === 'available') {
        lines.push('“Typical” is the median of the ' + s.exact_n + ' formulas with fixed daily directions.');
      }
      return lines;
    }

    function statusLine(r, target) {
      var bits = [state.example ? 'Example label' : target.origin === 'catalogue' ? 'From our review' : 'From your label'];
      if (/gbp$/.test(r.metric_id)) bits.push('before delivery');
      if (r.range_origin === 'routine') bits.push('range from the daily directions');
      else if (r.range_origin === 'declared_quantity') bits.push('range from the label amount');
      else if (r.range_origin === 'mixed') bits.push('range from the amount and directions');
      return bits.join(' · ');
    }

    /**
     * "Where you sit": one dot per comparable formula, in rank order.
     * Filled dots are definitely below your label (or more expensive), ringed dots
     * depend on label ranges, grey dots are equal or above. Shown only with 10+ peers.
     */
    function strip(r) {
      var p = r.position;
      if (!p || r.benchmark_state !== 'available') return null;
      var cost = E.BENCHMARK_METRICS[r.metric_id].direction === 'cost';
      var L = p.definite_count, H = p.possible_count, n = p.n;
      var dots = [];
      for (var i = 0; i < n; i++) {
        if (i === L) dots.push(el('span', { class: 'acmp-strip-you' }));
        dots.push(el('span', { class: 'acmp-strip-dot' + (i < L ? ' acmp-strip-dot--below' : i < H ? ' acmp-strip-dot--maybe' : '') }));
      }
      if (L >= n) dots.push(el('span', { class: 'acmp-strip-you' }));
      var label = 'Among ' + n + ' comparable formulas, ' + L + ' ' + (cost ? 'cost more' : 'have a lower amount') + ' than yours' +
        (H > L ? ', ' + (H - L) + ' depend on label ranges' : '') + ', and ' + (n - H) + ' are equal or ' + (cost ? 'cost less' : 'higher') + '.';
      return el('div', { class: 'acmp-strip', role: 'img', 'aria-label': label }, [
        el('div', { class: 'acmp-strip-track' }, dots),
        el('div', { class: 'acmp-strip-scale', 'aria-hidden': 'true' }, [
          el('span', { text: cost ? 'Costs more' : 'Lower amount' }), el('span', { text: cost ? 'Costs less' : 'Higher amount' })
        ]),
        el('p', { class: 'acmp-strip-key', 'aria-hidden': 'true' }, [
          el('span', null, [el('i'), cost ? 'Costs more than yours' : 'Lower than yours']),
          H > L ? el('span', null, [el('i', { class: 'is-maybe' }), 'Depends on ranges']) : null,
          el('span', null, [el('i', { class: 'is-you' }), 'Your label'])
        ])
      ]);
    }

    function card(r, target) {
      var v = splitValue(r.presentation.formatted_value);
      var pos = positionLine(r);
      var typ = typical(r);
      var how = [r.presentation.explanation].concat(marketLines(r));
      return el('article', { class: 'acmp-card', 'data-metric': r.metric_id }, [
        el('p', { class: 'acmp-kicker', text: r.title }),
        el('p', { class: 'acmp-value' }, [
          v.prefix ? el('span', { class: 'acmp-value-pre', text: v.prefix }) : null,
          el('span', { class: 'acmp-value-num', text: v.value }),
          v.unit ? el('span', { class: 'acmp-value-unit', text: v.unit }) : null
        ]),
        el('p', { class: 'acmp-status', text: statusLine(r, target) }),
        pos ? el('p', { class: 'acmp-position' + (pos.muted ? ' is-muted' : ''), text: pos.text }) : null,
        strip(r),
        typ ? el('p', { class: 'acmp-typical', text: typ }) : null,
        el('details', { class: 'acmp-how' }, [el('summary', { text: 'How this was worked out' })].concat(how.map(function (t) { return el('p', { text: t }); })))
      ]);
    }

    // The engine's next step, worded for the V2 form where it differs.
    function nextStep(r) {
      if (has(r.reason_codes, 'MARKER_NOT_LINKED') || has(r.reason_codes, 'PARENT_AMOUNT_UNAVAILABLE')) {
        return 'This needs the actual extract or powder amount in step 1. A percentage can’t be applied to an “equivalent to” amount.';
      }
      if (has(r.reason_codes, 'BASIS_MISSING')) return 'Add the serving size in step 2, for example per 2 capsules.';
      return r.presentation.next_input;
    }

    function listRow(r, withLine) {
      var pos = withLine ? positionLine(r) : null;
      // The name already says "per day" or "per 100 mg …", so the value doesn't repeat it.
      var value = r.presentation.formatted_value;
      if (/^cost_per_1(00)?mg_/.test(r.metric_id)) value = value.replace(/ per 1(00)? mg .*$/, '');
      else if (/_mg_day$/.test(r.metric_id)) value = value.replace(/ per day$/, '');
      return el('li', { 'data-metric': r.metric_id }, [
        el('span', { class: 'acmp-list-name', text: r.title }),
        el('span', { class: 'acmp-list-value', text: value }),
        pos ? el('span', { class: 'acmp-list-line', text: pos.text }) : null
      ]);
    }

    function callout(title, text, extra) {
      return el('div', { class: 'acmp-callout' }, [el('strong', { text: title }), text ? el('p', { text: text }) : null].concat(extra || []));
    }

    function question(text, answers) {
      return el('div', { class: 'acmp-question' }, [
        el('p', { text: text }),
        el('div', { class: 'acmp-button-row' }, answers.map(function (a) {
          return el('button', { type: 'button', class: 'acmp-secondary', 'data-comparison-answer': a[1] + '=' + a[2], text: a[0] });
        }))
      ]);
    }

    var scopeReason = null;
    var OUT_OF_SCOPE_SHORT = {
      single_ingredient: 'Not ranked: the comparison covers products with both ingredients.',
      age_population: 'Not ranked: the comparison covers adult products only.',
      product_type: 'Not ranked: this type of product is outside the comparison.'
    };
    var OUT_OF_SCOPE = {
      single_ingredient: 'The comparison covers products with both ashwagandha and lion’s mane, so your own numbers are shown without a ranking.',
      age_population: 'The comparison covers products for adults only, so your own numbers are shown without a ranking.',
      product_type: 'This type of product is outside the comparison, so its own numbers are shown without a ranking.'
    };

    /* ----- results: layout ----- */

    function render(resp, target, skipped) {
      resultList.textContent = '';
      scopeReason = resp.scope_state.reason || null;
      var byId = {};
      resp.results.forEach(function (r) { byId[r.metric_id] = r; });
      var T = null;
      resp.results.some(function (r) { if (r.cohort) { T = r.cohort.T; return true; } return false; });

      var intro = state.example ? EXAMPLE_TEXT
        : target.origin === 'catalogue' ? 'Recorded label details for ' + target.display_name + ', reviewed ' + longDate(target.reviewed_at) + '.'
        : 'From the details you entered' + (state.linked ? ', starting from ' + state.linked.label : '') + '.';
      if (T) intro += ' Compared with ' + T + ' reviewed adult formulas' + (resp.target.source_formula_id ? ' (not counting this one)' : '') + '.';
      resultList.appendChild(el('p', { class: 'acmp-intro', text: intro }));

      if (resp.dataset_state !== 'available') {
        resultList.appendChild(callout('Comparison unavailable', 'The reviewed formulas did not load, so you are seeing your own numbers only. Your entries are kept.',
          [el('div', { class: 'acmp-button-row' }, [el('button', { type: 'button', class: 'acmp-secondary', 'data-comparison-retry': true, text: 'Try loading the comparison again' })])]));
      }
      if (skipped.length) {
        var names = skipped.map(function (e) { return fieldInfo(e.field).label; }).filter(function (x, i, a) { return a.indexOf(x) === i; });
        resultList.appendChild(callout('Some details were left out', 'Not used: ' + names.join(', ') + '. Correct them and update to include them.'));
      }
      if (resp.scope_state.state === 'unconfirmed' && resp.dataset_state === 'available') {
        var f = resp.scope_state.fields;
        var qs = [];
        if (has(f, 'ashwagandha_present')) qs.push(question('Does it contain ashwagandha?', [['Yes, but no amount is listed', 'ash_presence', 'yes'], ['No', 'ash_presence', 'no']]));
        if (has(f, 'lions_mane_present')) qs.push(question('Does it contain lion’s mane?', [['Yes, but no amount is listed', 'lm_presence', 'yes'], ['No', 'lm_presence', 'no']]));
        if (has(f, 'age_population')) qs.push(question('Is it for adults?', [['Yes', 'is_adult', 'yes'], ['No, it’s for children', 'age_population', 'children']]));
        resultList.appendChild(callout('See where it sits', 'Answer ' + (qs.length === 1 ? 'this question' : 'these questions') + ' to compare with reviewed formulas. Your own numbers below don’t need it.', qs));
      } else if (resp.scope_state.state === 'out_of_scope') {
        resultList.appendChild(callout('Shown without a ranking', OUT_OF_SCOPE[resp.scope_state.reason] || 'This product isn’t part of the adult comparison group, so its own numbers are shown without a ranking.'));
      }

      if (resp.overall_state === 'NO_USABLE_INPUT') {
        resultList.appendChild(callout('Nothing to work out yet', 'Add at least one amount with its serving size, or a price and pack size.'));
        return finish();
      }

      var primary = resp.primary.map(function (id) { return byId[id]; }).filter(Boolean);
      resultList.appendChild(el('div', { class: 'acmp-cards' }, primary.map(function (r) { return card(r, target); })));

      var usable = resp.results.filter(function (r) { return r.calculation_state !== 'unavailable' && !has(resp.primary, r.metric_id); });
      var more = usable.filter(function (r) { return E.BENCHMARK_METRICS[r.metric_id] || r.metric_id === 'days_of_supply'; });
      var other = usable.filter(function (r) { return !has(more, r); });
      var missing = resp.results.filter(function (r) { return r.calculation_state === 'unavailable'; });

      if (more.length) {
        resultList.appendChild(el('section', { class: 'acmp-list-wrap', 'aria-label': 'More results' }, [
          el('h3', { text: 'More results' }),
          el('ul', { class: 'acmp-list' }, more.map(function (r) { return listRow(r, true); })),
          more.some(function (r) { return /^cost_per_1/.test(r.metric_id); })
            ? el('p', { class: 'acmp-footnote', text: 'Each “cost per mg” uses the whole product price, so these figures can’t be added together.' }) : null
        ]));
      }

      if (other.length || missing.length) {
        var body = [];
        if (other.length) body.push(el('h4', { text: 'Other figures' }), el('ul', { class: 'acmp-list' }, other.map(function (r) { return listRow(r, false); })));
        if (missing.length) {
          body.push(el('h4', { text: 'Not worked out' }), el('ul', { class: 'acmp-missing' }, missing.map(function (r) {
            return el('li', { 'data-metric': r.metric_id }, [el('strong', { text: r.title }), el('p', { text: r.presentation.explanation }),
              nextStep(r) ? el('p', { text: nextStep(r) }) : null]);
          })));
        }
        resultList.appendChild(el('details', { class: 'acmp-acc' }, [
          el('summary', { text: missing.length ? 'Details, and what we couldn’t work out' : 'Details' }),
          el('div', { class: 'acmp-acc-body' }, body)
        ]));
      }
      return finish();

      function finish() {
        resultList.appendChild(el('p', { class: 'acmp-footnote', text: 'These are label measurements. They don’t predict effects, and there’s no overall quality or “best supplement” score.' }));
        results.hidden = false;
      }
    }

    /* ----- stale results ----- */

    function markStale() {
      if (!state.hasResults || state.stale) return;
      state.stale = true;
      results.classList.add('is-stale');
      var intro = resultList.querySelector('.acmp-intro');
      var notice = el('p', { class: 'acmp-stale', text: 'Your details changed. Select “Update results” to refresh these numbers.' });
      resultList.insertBefore(notice, intro ? intro.nextSibling : resultList.firstChild);
      status.textContent = 'Details changed. Select Update results to recalculate.';
    }

    /* ----- events ----- */

    form.addEventListener('submit', function (ev) { ev.preventDefault(); run(false); });
    form.addEventListener('input', function (ev) {
      state.example = false;
      markStale();
      if (ev.target.name === 'routine_min' || ev.target.name === 'routine_max') updateUnits();
    });
    form.addEventListener('change', function (ev) {
      var t = ev.target;
      state.example = false;
      markStale();
      if (t === productSelect) showProductSummary();
      if (t.hasAttribute('data-comparison-route')) showRoute();
      if (t.name === 'pack_unit') state.packTouched = true;
      if (t.name === 'basis_unit' || t.name === 'routine_unit' || t.name === 'pack_unit') updateUnits();
    });

    root.addEventListener('click', function (ev) {
      var t = ev.target.closest ? ev.target.closest('button') : null;
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-comparison-example')) {
        clearManual();
        state.linked = null;
        showSourceBanner();
        setRoute('manual');
        Object.keys(EXAMPLE).forEach(function (k) { setField(k, EXAMPLE[k]); });
        state.packTouched = true;
        updateUnits();
        state.example = true;
        run(false);
      } else if (t.hasAttribute('data-comparison-edit-product')) {
        var rec = selectedRecord();
        if (rec) { prefillFrom(rec); markStale(); }
      } else if (t.hasAttribute('data-comparison-unlink')) {
        state.linked = null;
        form.elements.offer_orderability.value = '';
        showSourceBanner();
        markStale();
        status.textContent = 'This is now treated as a different product.';
      } else if (t.hasAttribute('data-comparison-skip-invalid')) {
        run(true);
      } else if (t.hasAttribute('data-comparison-retry')) {
        t.disabled = true;
        t.textContent = 'Loading…';
        loadDataset();
      } else if (t.hasAttribute('data-comparison-answer')) {
        var pair = t.getAttribute('data-comparison-answer').split('=');
        setField(pair[0], pair[1]);
        if (pair[0] === 'age_population') setField('is_adult', false);
        run(state.ignoreInvalid);
      } else if (t.hasAttribute('data-comparison-reveal')) {
        var box = doc.getElementById(t.getAttribute('data-comparison-reveal'));
        if (!box) return;
        var open = box.hidden;
        if (box.id === 'routine-range') setRange(open); else { box.hidden = !open; t.setAttribute('aria-expanded', String(open)); }
        if (open) { var first = box.querySelector('input'); if (first) first.focus(); } else { markStale(); updateUnits(); }
      }
    });

    showRoute();
    showSourceBanner();
    updateUnits();
    loadDataset();
  }

  function boot() {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-comparison-root]'), init);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
  // Shopify theme editor reloads sections without a page load.
  doc.addEventListener('shopify:section:load', boot);

  win.AshlionComparisonUI = { init: init };
})(window, document);
